import {
  getRecommendationRailV2,
  KuxFilteredCategoriesDTO,
  KuxMediaAssetType,
  UIDAPresentationTypeEnum,
} from '@kaltura-ott/tvpil';
import { action } from 'mobx';
import { lastValueFrom } from 'rxjs';
import { container } from 'tsyringe';

import { DmsStore } from '../../../../dms';
import { CardPlaceholder, EntitiesType } from '../../../../entities';
import { creatorEntityStore } from '../../../../entities/entities.service';
import { getItemsInPage, DEFAULT_PAGE_SIZE } from '../rail-store-helper-v2';
import { RailStoreV2 } from '../rail-store-v2';

export class RecommendationsRailStoreV2 extends RailStoreV2<EntitiesType> {
  subtype: UIDAPresentationTypeEnum.suggested = UIDAPresentationTypeEnum.suggested;
  protected partnerListTypeIn?: number;
  protected filterWatched?: boolean;
  protected orderBy?: string;

  private dmsStore: DmsStore;

  constructor(
    categoryTree: KuxFilteredCategoriesDTO,
    parentCategoryTree: KuxFilteredCategoriesDTO,
    children?: [],
    filterWatched?: boolean,
    orderBy?: string,
  ) {
    super(categoryTree, parentCategoryTree, children);

    this.dmsStore = container.resolve<DmsStore>('dmsStore');
    this.partnerListTypeIn = categoryTree.partnerListTypeIn;
    this.filterWatched = filterWatched;
    this.orderBy = orderBy;
  }

  protected async getData(
    pageIndex: number,
    items: (EntitiesType | CardPlaceholder)[],
  ): Promise<{ items: (EntitiesType | CardPlaceholder)[]; totalCount: number; newItems: EntitiesType[] }> {
    // TODO because filtering by continue watching - need to recursive loading
    const newRailData = await lastValueFrom(
      getRecommendationRailV2({
        pageSize: DEFAULT_PAGE_SIZE,
        pageIndex: pageIndex,
        kSql: this.aggregatedKSQL,
        groupBy: this.groupBy,
        partnerListTypeIn: this.partnerListTypeIn || this.dmsStore.dms?.savedInterestItemsList,
        filterWatched: this.filterWatched,
        orderBy: this.orderBy,
        isGroupedGrid: this.categoryTree.railProperty.isGroupedGrid,
      }),
    );

    const newItems = newRailData.items
      .slice(0, this.pageSize)
      .map((item: KuxMediaAssetType) => creatorEntityStore(item));
    this.innerItems.push(...newItems);

    return {
      totalCount: newRailData.totalCount,
      items: this.items,
      newItems,
    };
  }

  protected async getAdditionData(itemsInPage: EntitiesType[]): Promise<void> {}

  @action
  protected async restoreAdditionData(pageIndex: number, items: EntitiesType[]): Promise<void> {
    return this.getAdditionData(getItemsInPage(items, pageIndex));
  }
}
